module.exports = __webpack_public_path__ + "img/file.107e483d.svg";